"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } var _class;

var _chunkW75D6YWLcjs = require('./chunk-W75D6YWL.cjs');


var _chunkI4SOZEKKcjs = require('./chunk-I4SOZEKK.cjs');


var _chunkWF6EZ2CWcjs = require('./chunk-WF6EZ2CW.cjs');


var _chunkKBINKP7Dcjs = require('./chunk-KBINKP7D.cjs');


var _chunkQBYZPWDOcjs = require('./chunk-QBYZPWDO.cjs');

// src/contracts/pTON/v1/PtonV1.ts




var _ton = require('@ton/ton');
var PtonV1 = (_class = class _PtonV1 extends _chunkWF6EZ2CWcjs.JettonMinter {
  static __initStatic() {this.version = _chunkI4SOZEKKcjs.pTON_VERSION.v1}
  static __initStatic2() {this.address = _ton.address.call(void 0, 
    "EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez"
  )}
  static __initStatic3() {this.gasConstants = {
    deployWallet: _ton.toNano.call(void 0, "1.05")
  }}
  __init() {this.version = _PtonV1.version}
  
  constructor(address2 = _PtonV1.address, { gasConstants, ...options } = {}) {
    super(address2, options);_class.prototype.__init.call(this);;
    this.gasConstants = {
      ..._PtonV1.gasConstants,
      ...gasConstants
    };
  }
  async getTonTransferTxParams(provider, params) {
    const to = await this.getWalletAddress(provider, params.destinationAddress);
    const body = _chunkKBINKP7Dcjs.createJettonTransferMessage.call(void 0, {
      queryId: _nullishCoalesce(params.queryId, () => ( 0)),
      amount: params.tonAmount,
      destination: params.destinationAddress,
      forwardTonAmount: BigInt(_nullishCoalesce(params.forwardTonAmount, () => ( 0))),
      forwardPayload: params.forwardPayload
    });
    const value = BigInt(params.tonAmount) + BigInt(_nullishCoalesce(params.forwardTonAmount, () => ( 0)));
    return { to, value, body };
  }
  async sendTonTransfer(provider, via, params) {
    const txParams = await this.getTonTransferTxParams(provider, params);
    return via.send(txParams);
  }
  async createDeployWalletBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkW75D6YWLcjs.pTON_OP_CODES.DEPLOY_WALLET, 32).storeUint(_nullishCoalesce(params.queryId, () => ( 0)), 64).storeAddress(_chunkQBYZPWDOcjs.toAddress.call(void 0, params.ownerAddress)).endCell();
  }
  async getDeployWalletTxParams(provider, params) {
    const to = this.address;
    const body = await this.createDeployWalletBody({
      ownerAddress: params.ownerAddress,
      queryId: _optionalChain([params, 'optionalAccess', _ => _.queryId])
    });
    const value = BigInt(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _2 => _2.gasAmount]), () => ( this.gasConstants.deployWallet)));
    return { to, value, body };
  }
  async sendDeployWallet(provider, via, params) {
    const txParams = await this.getDeployWalletTxParams(provider, params);
    return via.send(txParams);
  }
}, _class.__initStatic(), _class.__initStatic2(), _class.__initStatic3(), _class);



exports.PtonV1 = PtonV1;
//# sourceMappingURL=chunk-LRJOJOOS.cjs.map